"use strict";
/* tslint:disable:max-line-length */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var product_suggestion_1 = require("./product_suggestion");
var product_preview_1 = require("../product_search_form/product_preview");
var photos_1 = require("../photos/photos");
var url_helpers_1 = require("../shared/url_helpers");
var api_request_1 = require("../api_request");
var lodash_1 = require("lodash");
var bind_1 = require("../../bind");
var uuid_1 = require("../../lib/uuid");
var I18n = require("i18n-js");
var URLS_REGEX = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/gi;
var ControlledBodyInput = /** @class */ (function (_super) {
    tslib_1.__extends(ControlledBodyInput, _super);
    function ControlledBodyInput(props) {
        var _this = _super.call(this, props) || this;
        _this.uuid = uuid_1.default();
        _this.state = {
            productSuggestionOpen: false,
            photosOpen: false,
            loadedProducts: [],
            embeddedProductIds: [],
        };
        return _this;
    }
    Object.defineProperty(ControlledBodyInput.prototype, "showProductSuggest", {
        get: function () {
            return this.props.isSeller && !this.props.hideListingSearch;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlledBodyInput.prototype, "loadedProductIds", {
        get: function () {
            return this.state.loadedProducts.map(function (product) { return product.id.toString(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlledBodyInput.prototype, "embeddedLoadedProducts", {
        get: function () {
            var _this = this;
            // return in the same order as this.state.embeddedProductIds
            var products = this.state.embeddedProductIds.map(function (id) {
                return _this.loadedProductById(id);
            });
            return lodash_1.compact(products);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlledBodyInput.prototype, "showPhotos", {
        get: function () {
            return this.state.photosOpen || this.props.photos.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    ControlledBodyInput.prototype.handleChange = function (e) {
        this.props.onChange(e.target.value);
        this.parseProductEmbeds(e.target.value);
    };
    ControlledBodyInput.prototype.handleOpenPhotos = function (e) {
        e.preventDefault();
        this.setState({ photosOpen: true });
    };
    ControlledBodyInput.prototype.handleToggleProductSuggestion = function (e) {
        e.preventDefault();
        this.setState({
            productSuggestionOpen: !this.state.productSuggestionOpen,
        });
    };
    ControlledBodyInput.prototype.handleProductSelected = function (product) {
        var link = product._links.web.href;
        var updatedMessage = this.appendLink(link);
        this.props.onChange(updatedMessage);
        this.setState({
            productSuggestionOpen: false,
            loadedProducts: this.state.loadedProducts.concat([product]),
            embeddedProductIds: this.state.embeddedProductIds.concat([product.id.toString()]),
        });
        var textarea = this.refs.textarea;
        if (textarea) {
            textarea.focus();
        }
    };
    ControlledBodyInput.prototype.appendLink = function (link) {
        var message = this.props.message;
        // separate by 2 newlines, unless there is nothing typed yet
        if (message.length === 0) {
            return link;
        }
        if (/\n\n$/.test(message)) {
            return message + link;
        }
        if (/\n$/.test(message)) {
            return message + "\n" + link;
        }
        return message + "\n\n" + link;
    };
    ControlledBodyInput.prototype.parseProductEmbeds = function (message) {
        var links = message.match(URLS_REGEX) || [];
        var regex = new RegExp('\\/item\\/(\\d+)');
        var productIds = [];
        links.forEach(function (link) {
            var match = link.match(regex);
            if (match) {
                productIds.push(match[1]);
            }
        });
        productIds = lodash_1.uniq(productIds);
        if (!lodash_1.isEqual(this.state.embeddedProductIds, productIds)) {
            this.setState({ embeddedProductIds: productIds });
        }
        this.loadProducts(productIds);
    };
    ControlledBodyInput.prototype.loadProducts = function (ids) {
        var _this = this;
        ids.forEach(function (id) {
            if (!_this.hasLoadedProduct(id)) {
                _this.loadProduct(id);
            }
        });
    };
    ControlledBodyInput.prototype.loadProduct = function (id) {
        var _this = this;
        api_request_1.V3.get(url_helpers_1.default.listingPath(id)).then(function (response) {
            _this.setState({
                loadedProducts: _this.state.loadedProducts.concat([response]),
            });
        });
    };
    ControlledBodyInput.prototype.hasLoadedProduct = function (id) {
        return this.loadedProductIds.includes(id.toString());
    };
    ControlledBodyInput.prototype.loadedProductById = function (id) {
        return this.state.loadedProducts.find(function (product) {
            return product.id.toString() === id.toString();
        });
    };
    ControlledBodyInput.prototype.inputName = function (field) {
        if (this.props.inputNamespace) {
            return this.props.inputNamespace + "[" + field + "]";
        }
        return field;
    };
    Object.defineProperty(ControlledBodyInput.prototype, "domId", {
        get: function () {
            return "message-box-" + this.uuid;
        },
        enumerable: true,
        configurable: true
    });
    ControlledBodyInput.prototype.renderProductSuggestionToggle = function () {
        if (!this.showProductSuggest) {
            return null;
        }
        var classes = classNames('message-box__action', 'message-box__action--listing', {
            'message-box__action--active': this.state.productSuggestionOpen,
        });
        return (React.createElement("button", { className: classes, onClick: this.handleToggleProductSuggestion }, I18n.t('discovery.messages.attach_listings')));
    };
    ControlledBodyInput.prototype.renderProductSuggestion = function () {
        if (!this.showProductSuggest || !this.state.productSuggestionOpen) {
            return null;
        }
        return (React.createElement("div", { className: "message-box__suggest-form" },
            React.createElement(product_suggestion_1.default, { currentListingIds: lodash_1.compact([this.props.productId]), analyticsSource: this.props.analyticsSource, onProductSelected: this.handleProductSelected })));
    };
    ControlledBodyInput.prototype.renderAttachImageLink = function () {
        if (!this.props.allowPhotos) {
            return null;
        }
        var classes = classNames('message-box__action message-box__action--photos', {
            'message-box__action--active': this.showPhotos,
        });
        return (React.createElement("button", { onClick: this.handleOpenPhotos, className: classes }, I18n.t('discovery.messages.attach_images')));
    };
    ControlledBodyInput.prototype.renderTextarea = function () {
        return (React.createElement("textarea", { name: this.inputName(this.props.bodyInputName), value: this.props.message, onChange: this.handleChange, ref: "textarea", placeholder: I18n.t('discovery.messages.body.placeholder'), "data-detector": "input", "data-message-body": true }));
    };
    ControlledBodyInput.prototype.renderProductEmbeds = function () {
        return this.embeddedLoadedProducts.map(function (product) { return (React.createElement("div", { className: "message-form__listing-preview", key: product.id },
            React.createElement(product_preview_1.default, { product: product }))); });
    };
    ControlledBodyInput.prototype.renderPhotoUpload = function () {
        if (!this.showPhotos) {
            return null;
        }
        return (React.createElement(photos_1.ControlledPhotos, { photos: this.props.photos, onPhotosChange: this.props.onPhotosChange, inputName: this.inputName('photos'), uploadOptions: this.props.photoUploadOptions, requireMinimumDimensions: false, allowEdit: false, renderTip: false, dropZoneSelector: "#" + this.domId }));
    };
    ControlledBodyInput.prototype.renderAttachments = function () {
        if (this.showPhotos || this.embeddedLoadedProducts.length > 0) {
            return (React.createElement("div", { className: "message-box__attachments" },
                this.renderPhotoUpload(),
                this.renderProductEmbeds()));
        }
    };
    ControlledBodyInput.prototype.render = function () {
        return (React.createElement("div", { className: "message-box", id: this.domId },
            React.createElement("div", { className: "message-box__text" }, this.renderTextarea()),
            React.createElement("div", { className: "message-box__content" },
                this.renderAttachments(),
                this.renderProductSuggestion()),
            (this.props.allowPhotos || this.showProductSuggest) &&
                React.createElement("div", { className: "message-box__actions" },
                    this.renderAttachImageLink(),
                    this.renderProductSuggestionToggle())));
    };
    ControlledBodyInput.defaultProps = {
        bodyInputName: 'body',
        allowPhotos: true,
        isRequired: true,
        photoUploadOptions: {},
        hideListingSearch: false,
        hostURL: WEB_HOST,
    };
    tslib_1.__decorate([
        bind_1.default
    ], ControlledBodyInput.prototype, "handleChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], ControlledBodyInput.prototype, "handleOpenPhotos", null);
    tslib_1.__decorate([
        bind_1.default
    ], ControlledBodyInput.prototype, "handleToggleProductSuggestion", null);
    tslib_1.__decorate([
        bind_1.default
    ], ControlledBodyInput.prototype, "handleProductSelected", null);
    return ControlledBodyInput;
}(React.Component));
exports.ControlledBodyInput = ControlledBodyInput;
var UncontrolledBodyInput = /** @class */ (function (_super) {
    tslib_1.__extends(UncontrolledBodyInput, _super);
    function UncontrolledBodyInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            message: '',
            photos: [],
        };
        return _this;
    }
    UncontrolledBodyInput.prototype.handleChange = function (newMessage) {
        this.setState({ message: newMessage });
    };
    UncontrolledBodyInput.prototype.handlePhotosChange = function (photos) {
        this.setState({ photos: photos });
    };
    UncontrolledBodyInput.prototype.render = function () {
        return (React.createElement(ControlledBodyInput, tslib_1.__assign({}, this.props, { message: this.state.message, onChange: this.handleChange, photos: this.state.photos, onPhotosChange: this.handlePhotosChange })));
    };
    tslib_1.__decorate([
        bind_1.default
    ], UncontrolledBodyInput.prototype, "handleChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], UncontrolledBodyInput.prototype, "handlePhotosChange", null);
    return UncontrolledBodyInput;
}(React.Component));
exports.UncontrolledBodyInput = UncontrolledBodyInput;
//# sourceMappingURL=body_input.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/messages/body_input.js
// module id = YeVD
// module chunks = 20 21